import { getApiClient, getApiInternalClient } from '..';
import getSession from '../../utilities/getSession';
import withAuthenticationHeaders from '../../utilities/withAuthenticationHeaders';
import isInternalPaymentRequest from '../../validators/isInternalPaymentRequest';

export default function postPaymentMethodData(
  pr: io.flow.v0.models.PaymentRequest | io.flow.internal.v0.models.InternalPaymentRequest,
  paymentMethodData: io.flow.v0.unions.PaymentMethodData,
): Promise<io.flow.v0.models.PaymentRequest | io.flow.internal.v0.models.InternalPaymentRequest> {
  const id = isInternalPaymentRequest(pr) ? pr.payment_request.id : pr.id;
  return getSession().then((session) => (isInternalPaymentRequest(pr)
    ? getApiInternalClient().paymentRequest.postPaymentAndMethodAndData({
      id,
      organization: session.organization,
      body: paymentMethodData,
      headers: withAuthenticationHeaders(session.id),
    })
    : getApiClient().paymentRequest.postPaymentAndMethodAndDataById({
      id,
      organization: session.organization,
      body: paymentMethodData,
      headers: withAuthenticationHeaders(session.id),
    })
  ).then((response) => {
    if (response.ok) {
      return response.body;
    }
    const errorMessages = response.body?.messages.join(', ');
    throw new Error(`postPaymentMethodData: Error posting payment data for ${id}${errorMessages ? ` = ${errorMessages}` : ''}`);
  }));
}
